import React, { useState, useContext, useEffect } from 'react';
import { List, ListItem, Tooltip } from '@mui/material';
import FloodIcon from '@mui/icons-material/Water';
import FireIcon from '@mui/icons-material/LocalFireDepartment';
import HurricaneIcon from '@mui/icons-material/Storm';
import SchoolIcon from '@mui/icons-material/School';
import { authContext } from '../../../Context/Authentication/authContext';

const LayersComponent = (props: any) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const { state }: any = useContext(authContext);

  useEffect(() => {
    setSelectedIndex(null);
  }, [state.filters.selectedTerritory]);

  const handleItemClick = (index: number, text: string) => {
    if(index===selectedIndex){
      setSelectedIndex(null)
      props.handleLayer('default');

    }
    else{
      setSelectedIndex(index);
      props.handleLayer(text);

    }
   
  };
  const allStates = [
    "Florida",
    "Texas",
    "California",
    "Tennessee",
    "Arizona",
    "Indiana",
    "North Carolina",
    "Georgia",
    "Colorado",
    "South Carolina"
  ];
  const states_list = [
    'Alabama', 'Arkansas', 'Connecticut', 'Delaware', 'Iowa', 'Kansas', 
    'Kentucky', 'Louisiana', 'Maryland', 'Michigan', 'Mississippi', 
    'Missouri', 'Ohio', 'Pennsylvania', 'West Virginia', 'Nebraska', 
    'Vermont', 'Massachusetts', 'New Mexico', 'Hawaii', 'South Dakota', 
    'Alaska', 'Rhode Island', 'New Hampshire', 'Nevada', 'New Jersey', 
    'New York', 'Oklahoma','Wisconsin'
  ];
  

  const additionalStates = states_list.map(state => ({ 'state':state, disabled: true }));
  
  const layers = [
    { 
      text: 'Flood', 
      icon: <FloodIcon />, 
      description: 'Flood warning layer', 
      states: [
        { state: 'Florida', disabled: false },
        { state: 'Texas', disabled: true },
        { state: 'California', disabled: true },
        { state: 'Tennessee', disabled: true },
        { state: 'Arizona', disabled: true },
        { state: 'Indiana', disabled: true },
        { state: 'North Carolina', disabled: true },
        { state: 'South Carolina', disabled: true },
        { state: 'Georgia', disabled: true },
        { state: 'Colorado', disabled: true },
        { state: 'Illinois', disabled: true },
        { state: 'Idaho', disabled: true },
        { state: 'Minnesota', disabled: true },
        { state: 'Utah', disabled: true },
        { state: 'Washington', disabled: true },
        { state: 'Oregon', disabled: true },
        ...additionalStates
      ], 
      disabled: true 
    },
    { 
      text: 'Fire', 
      icon: <FireIcon />, 
      description: 'Fire hazard layer', 
      states: [
        { state: 'Florida', disabled: true },
        { state: 'Texas', disabled: true },
        { state: 'California', disabled: false },
        { state: 'Tennessee', disabled: true },
        { state: 'Arizona', disabled: true },
        { state: 'Indiana', disabled: true },
        { state: 'North Carolina', disabled: true },
        { state: 'Georgia', disabled: true },
        { state: 'Colorado', disabled: true },
        { state: 'South Carolina', disabled: true },
        { state: 'Illinois', disabled: true },
        { state: 'Idaho', disabled: true },
        { state: 'Minnesota', disabled: true },
        { state: 'Utah', disabled: true },
        { state: 'Washington', disabled: true },
        { state: 'Oregon', disabled: true },
        ...additionalStates
      ], 
      disabled: false 
    },
    { 
      text: 'Hurricane', 
      icon: <HurricaneIcon />, 
      description: 'Hurricane tracking layer', 
         states: [
      { state: 'Alabama', disabled: false },
      { state: 'Alaska', disabled: true },
      { state: 'Arizona', disabled: true },
      { state: 'Arkansas', disabled: false },
      { state: 'California', disabled: true },
      { state: 'Colorado', disabled: false },
      { state: 'Connecticut', disabled: false },
      { state: 'Delaware', disabled: true },
      { state: 'Florida', disabled: false },
      { state: 'Georgia', disabled: false },
      { state: 'Hawaii', disabled: false },
      { state: 'Idaho', disabled: false },
      { state: 'Illinois', disabled: false },
      { state: 'Indiana', disabled: false },
      { state: 'Iowa', disabled: false },
      { state: 'Kansas', disabled: false },
      { state: 'Kentucky', disabled: false },
      { state: 'Louisiana', disabled: false },
      { state: 'Maine', disabled: false },
      { state: 'Maryland', disabled: false },
      { state: 'Massachusetts', disabled: false },
      { state: 'Michigan', disabled: false },
      { state: 'Minnesota', disabled: false },
      { state: 'Mississippi', disabled: false },
      { state: 'Missouri', disabled: false },
      { state: 'Montana', disabled: false },
      { state: 'Nebraska', disabled: false },
      { state: 'Nevada', disabled: false },
      { state: 'New Hampshire', disabled: false },
      { state: 'New Jersey', disabled: false },
      { state: 'New Mexico', disabled: false },
      { state: 'New York', disabled: false },
      { state: 'North Carolina', disabled: false },
      { state: 'North Dakota', disabled: false },
      { state: 'Ohio', disabled: false },
      { state: 'Oklahoma', disabled: false },
      { state: 'Oregon', disabled: false },
      { state: 'Pennsylvania', disabled: false },
      { state: 'Rhode Island', disabled: false },
      { state: 'South Carolina', disabled: false },
      { state: 'South Dakota', disabled: false },
      { state: 'Tennessee', disabled: false },
      { state: 'Texas', disabled: false },
      { state: 'Utah', disabled: false },
      { state: 'Vermont', disabled: false },
      { state: 'Virginia', disabled: false },
      { state: 'Washington', disabled: false },
      { state: 'West Virginia', disabled: false },
      { state: 'Wisconsin', disabled: false },
      { state: 'Wyoming', disabled: false }
    ], 
      disabled: true 
    },
    { 
      text: 'School District', 
      icon: <SchoolIcon />, 
      description: 'School district boundaries', 
      states: [
        { state: 'North Carolina', disabled: false },
        { state: 'Colorado', disabled: false },
        { state: 'Florida', disabled: false },
        { state: 'Delaware', disabled: false },
        { state: 'Louisiana', disabled: false },
        { state: 'West Virginia', disabled: false },
        { state: 'South Carolina', disabled: false },
        { state: 'Arkansas', disabled: false },
        { state: 'Missouri', disabled: false },
        { state: 'Connecticut', disabled: false },
        { state: 'Iowa', disabled: false },
        { state: 'Indiana', disabled: false },
        { state: 'Ohio', disabled: false },
        { state: 'Michigan', disabled: false },
        { state: 'Pennsylvania', disabled: false },
        { state: 'Washington', disabled: false },
        { state: 'Kentucky', disabled: false },
        { state: 'Wisconsin', disabled: false },
        { state: 'Arizona', disabled: false },
        { state: 'Illinois', disabled: false },
        { state: 'Virginia', disabled: false },
        { state: 'Maryland', disabled: false },
        { state: 'Georgia', disabled: false },
        { state: 'Utah', disabled: false },
        { state: 'California', disabled: false },
        { state: 'Tennessee', disabled: false },
        { state: 'Oregon', disabled: false },
        { state: 'Texas', disabled: false },
        { state: 'Alabama', disabled: false },
        { state: 'Alaska', disabled: false },
        { state: 'Hawaii', disabled: false },
        { state: 'Idaho', disabled: true },
        { state: 'Kansas', disabled: true },
        { state: 'Massachusetts', disabled: false },
        { state: 'Minnesota', disabled: false },
        { state: 'Mississippi', disabled: false },
        { state: 'Montana', disabled: false },
        { state: 'Nebraska', disabled: false },
        { state: 'Nevada', disabled: false },
        { state: 'New Hampshire', disabled: false },
        { state: 'New Jersey', disabled: false },
        { state: 'New Mexico', disabled: false },
        { state: 'New York', disabled: false },
        { state: 'North Dakota', disabled: false },
        { state: 'Oklahoma', disabled: false },
        { state: 'Rhode Island', disabled: false },
        { state: 'South Dakota', disabled: false },
        { state: 'Vermont', disabled: false },
        { state: 'Wyoming', disabled: false }
      ],
      disabled: false 
    }
  ];

  // const filteredLayers = layers.filter((layer) => layer.states.includes(state.filters.selectedTerritory));

  // Calculate div width based on the number of icons
  const divWidth = layers.length * 60; // Adjust based on icon size and margin

  return (
    <div
  style={props.dialog?{
    width: `${divWidth}px`,
    position: 'fixed',
    bottom: '22.5%',
    left: '126px',
    background: 'linear-gradient(0deg, #13223D, #234f70 100%)',
    boxShadow: '4px 8px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '8px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  }:{
    width: `${divWidth}px`,
    position: 'fixed',
    bottom: props.schoolData.length!=0?'168px':'132px',
    left: '380px',
    background: 'linear-gradient(0deg, #13223D, #234f70 100%)',
    boxShadow: '4px 8px 4px 0px rgba(0, 0, 0, 0.25)',
    borderRadius: '8px',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  }}
>
  <List
    style={{
      display: 'flex',
      padding: 0,
      margin: 0,
    }}
  >
    {layers.map((item, index) => {
      const isDisabled = item.states.find((i)=>i.state===state.filters.selectedTerritory)?.disabled;
        

      return (
        <Tooltip key={index} title={item.description} arrow placement="bottom">
          <ListItem
            button
            onClick={() => !isDisabled && handleItemClick(index, item.text)} // Prevent click if disabled
            style={{
              flex: '0 0 auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              backgroundColor: selectedIndex === index ? '#f0f0f0' : 'transparent',
              transition: 'background-color 0.3s',
              height: '60px',
              width: '60px',
              opacity: isDisabled ? 0.5 : 1, // Change opacity if disabled
              cursor: isDisabled ? 'not-allowed' : 'pointer', // Change cursor if disabled
              pointerEvents: isDisabled ? 'none' : 'auto', // Disable pointer events if disabled
            }}
          >
            {React.cloneElement(item.icon, {
              style: {
                fontSize: 50,
                color: isDisabled ? 'gray' : selectedIndex === index ? 'black' : 'white', // Change color if disabled
              },
            })}
          </ListItem>
        </Tooltip>
      );
    })}
  </List>
</div>

  );
};

export default LayersComponent;